import React from 'react'

class Detail extends React.Component {

  mapStatus = (status) => {
    switch(status){
      case "geschlossen": return 0;
      case "1": return 1;
      case "2": return 2;
      case "3": return 3;
      case "4": return 4;
      default: return 1;
      }
  }

  render() {
    const data = this.props.data;

    return (
      <div className={"detail " + this.props.visibility} id="detail" style={{left: data.x, top: data.y}}>
        <div className="detail-container">
          <div className="detail-icons">
            <div className="detail-icon" onClick={this.props.closeDetail} >
              <img src="/x.svg" alt="X"/>
            </div>
          </div>

          {/*TODO: prettify */}
          {data.type === "lawplan" &&
            <div>
                <h2><a href={data.url} rel="noopener noreferrer" target="_blank" >B-Plan: {data.name}</a></h2>
                 <h4> {data.behoerde}</h4>
                 <h3> Öffentliche Auslegung: {data.auslegung}</h3>
                 <h3> Frühzeitige Beteiligung: {data.beteiligung}</h3>
                 <h3> Aufstellungsbeschluss: {data.beschluss}</h3>
            </div>

          }
           {data.type === "sanierung" &&
            <div>
                <h2>Sanierungsgebiet: {data.id}</h2>
                 <h4> {data.name}</h4>
            </div>
          }
          {data.type === "planziele" &&
            <div>
                <h4>Planziel: {data.planziel_name}</h4>
            </div>
          }

          {data.type === "club" &&
          <h2>{data.name}</h2>
          }

          {(data.type === "club" )&&
            <div className="detail-status">
              <h3>Status: </h3>
              <svg height="30" width="30">
                <circle className={"alert-level-" + this.mapStatus(data.status)} cx="15" cy="15" r="13" />
              </svg>
            </div>}

           </div>


      </div>
    );
  }
}
export default Detail
